import { toBooleanFromBit } from './vendorHelpers';

export const mapVendorFromApi = (row) => {
  if (!row) return null;
  return {
    VendorId: row.VendorId ?? null,
    VendorName: row.VendorName || '',
    VendorLogo: row.VendorLogo || '',
    Address: row.Address || '',
    ContactNumber: row.ContactNumber || '',
    Email: row.Email || '',
    Website: row.Website || '',
    Rating: row.Rating != null ? Number(row.Rating) : null,
    ReviewCount: row.ReviewCount ?? 0,
    IsActive: toBooleanFromBit(row.IsActive, true),
    CreatedDate: row.CreatedDate || null,
    ModifiedDate: row.ModifiedDate || null,
  };
};

export const buildVendorSavePayload = (data, userId) => ({
  VendorId: data.VendorId || null,
  VendorName: data.VendorName?.trim() || '',
  VendorLogo: data.VendorLogo?.trim() || null,
  Address: data.Address?.trim() || null,
  ContactNumber: data.ContactNumber?.trim() || null,
  Email: data.Email?.trim() || null,
  Website: data.Website?.trim() || null,
  Rating: data.Rating !== '' && data.Rating != null ? Number(data.Rating) : null,
  ReviewCount: data.ReviewCount ?? 0,
  IsActive: data.IsActive !== false && data.IsActive !== 0 ? 1 : 0,
  UserId: userId,
});
